import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import AnimateHeight from 'react-animate-height';
import * as StyledMobileNav from './mobileNavigation.styles';

const END_LEVEL = 2;

const onRouteClick = (item, history) => {
	// The reducer listens for FETCH_PAGE_PENDING and closes the nav
	history.push(item.Url);
};

const shouldRenderSubNav = (children, level) => {
	return children && children.filter(x => !x.Hidden).length > 0 && level < END_LEVEL;
};

export const traverseSubNav = items => items.map(item => !item.Hidden && (
	<StyledMobileNav.SubNavItem to={item.Url} key={item.Id}>
		{item.Name}
	</StyledMobileNav.SubNavItem>
));

const MobileNavItem = ({
	item,
	level,
	history
}) => {
	const [height, setHeight] = useState('0');

	const onSubNavLinkClick = (e) => {
		e.stopPropagation();
		setHeight(height === '0' ? 'auto' : '0');
	};

	return (
		<StyledMobileNav.NavItem>
			<StyledMobileNav.Anchor onClick={onRouteClick.bind(null, item, history)}>
				<span>{item.Name}</span>
				{
					shouldRenderSubNav(item.Children, level) && (
						<StyledMobileNav.SubNavLink onClick={onSubNavLinkClick} open={height !== '0'}>
							<FaChevronDown />
						</StyledMobileNav.SubNavLink>
					)
				}
			</StyledMobileNav.Anchor>
			{
				shouldRenderSubNav(item.Children, level) && (
					<AnimateHeight
						duration={250}
						height={height}>
						<StyledMobileNav.SubNav>
							{traverseSubNav(item.Children, level + 1, history)}
						</StyledMobileNav.SubNav>
					</AnimateHeight>
				)
			}
		</StyledMobileNav.NavItem>
	);
};

export default MobileNavItem;
